import type { AnyAction } from 'redux';

import { Actions } from '../actionTypes/actionTypes';
import { initialState } from './initialState';
import type { SessionExpiredAction, SessionExpiredState } from './types';

export const sessionExpiredReducer = (state: SessionExpiredState = initialState, action: AnyAction): SessionExpiredState => {
    switch (action.type) {
        case Actions.SESSION_EXPIRED:
            if (state.isSessionExpired) {
                return state;
            }
            return { isSessionExpired: true, trigger: (action as SessionExpiredAction).payload.trigger };
        default:
            return state;
    }
};
